import { render, staticRenderFns } from "./SlglrsPDFJSViewer.vue?vue&type=template&id=758d1418&"
import script from "./SlglrsPDFJSViewer.vue?vue&type=script&lang=js&"
export * from "./SlglrsPDFJSViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports